import { Metrics } from './Metrics'; // Export singleton

export default new Metrics();